import * as angular from 'angular';
import {IController, IOnChangesObject, IScope} from 'angular';
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {SplitService} from "../../../commons/services/split-service.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";

export class DeliveriesTableRowCtrl implements IController {

  id: any;
  isSelected: any;
  isExpended: any;
  columns: any;
  dynamicColumns: any;
  packageDynamicColumns: any;
  toggle: Function;
  onExpand: Function;
  onEditAddress: Function;
  onFilterByType: Function;

  public locationTypes: typeof LocationType = LocationType;
  private hasFleetManagementPermission: any;
  private hasPricePlanPermission: any;
  public canCopyProNumber: boolean;
  private service: any;
  private configZoneId: any;
  public itemsIds: string[] = [];
  public itemsTypes: string[] = [];
  private sitePackageItemsMap: any;
  private siteFiltersType: typeof SiteFiltersType = SiteFiltersType;

  constructor(private $delivery, private IAMPermissions, private splitService: SplitService,
              private $scope: IScope, private moment) {

    this.hasFleetManagementPermission = this.IAMPermissions.hasPermission('fleetManagement.vehicles.list');
    this.hasPricePlanPermission = this.IAMPermissions.hasPermission('priceplan.list');
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    this.configZoneId = this.splitService.getTimeZone();
  }

  $onInit() {
    if (this.id) {
      this.bindService();
    }
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.bindService();
    }
  };

  private bindService() {
    this.service = undefined;
    this.$delivery(this.id).$bindCtrlToId(this.$scope, this, 'service', 'id');
  }

  checkBoxClick() {
    this.toggle({serviceId: this.id});
  }

  onBeforeExpand() {
    const hasRelations = _.some(this.service.taskList, (t) => {
      return t.relations && t.relations.length;
    });
    if (hasRelations) {
      this.onExpand({serviceId: this.id});
    }
  }

  showProgressPercentage() {
    return Math.round((this.service.serviceProgress.stepNumber / this.service.serviceProgress.numberOfSteps) * 100);
  }

  isTimeToDeliverLate(notBefore) {
    if (!notBefore) {
      return false;
    }
    return this.moment(notBefore).valueOf() - this.moment().valueOf() <= 3600000; // 1 hour
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesTableRow', {
    bindings: {
      id: '<',
      isSelected: '<',
      isExpended: '<',
      columns: '<',
      dynamicColumns: '<?',
      packageDynamicColumns: '<?',
      toggle: '&',
      onExpand: '&',
      onEditAddress: '&',
      onFilterByType: '&'
    },
    template: require('./deliveries-table-row.html').default,
    controller: DeliveriesTableRowCtrl
  });
